export const LINK_TREE_LIST_SUCCESS = 'LINK_TREE_LIST_SUCCESS';
export const CREATE_LINK_TREE_SUCCESS = 'CREATE_LINK_TREE_SUCCESS';
export const EDIT_LINK_TREE_SUCCESS = 'EDIT_LINK_TREE_SUCCESS';
export const DELETE_LINK_TREE_SUCCESS = 'DELETE_LINK_TREE_SUCCESS';
